import React from 'react';
import { PolicyHolderType } from '../common/CommonTypes';
import FormInput from '../common/FormInput';
import Selectable from '../common/Selectable';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../Constants/Common';
import { useTranslation } from 'react-i18next';

export type PersonalDetailSectionProps = {
    customer: PolicyHolderType;
};
const PersonalDetailSection = ({
    customer
}: PersonalDetailSectionProps): JSX.Element => {
    const navigate = useNavigate();
    if (!customer) return <></>;

    const { t } = useTranslation();

    const customerName = [customer.title, customer.firstName, customer.lastName]
        .filter(Boolean)
        .join(' ');

    const onSelectClicked = () => {
        navigate(RoutePaths.PersonalDetails);
    };

    return (
        <FormInput id='personaldetails' label={t('personal_details')}>
            <Selectable
                id={`selectable-personal-detail`}
                onClicked={() => onSelectClicked()}
                selected={false}
                hasSelectableButton={true}
                buttonText={t('view')}
                style={{
                    border: '1px solid #ced4da',
                    marginTop: '10px'
                }}>
                <span>{customerName}</span>
                <br />
                <span>{customer.address.addressLine1}</span>
                <br />
                <span>{customer.address.townOrCity}</span>
                <br />
                <span>{customer.address.postcode}</span>
            </Selectable>
        </FormInput>
    );
};

export default PersonalDetailSection;
